import { request } from './api';
export const bookings = {
    async query(input = {}) {
        const query = new URLSearchParams(input.filters);
        if (input.limit !== undefined)
            query.set('limit', String(input.limit));
        return (await request(`/api/bookings?${query}`)).items;
    },
    create(data) { return request('/api/bookings', 'POST', data); },
    patch(id, data) { return request(`/api/bookings/${encodeURIComponent(id)}`, 'PATCH', data); },
    delete(id) { return request(`/api/bookings/${encodeURIComponent(id)}`, 'DELETE'); },
};
export const BOOKING_STATUSES = ["New", "Confirmed", "Waitlisted", "Completed", "Cancelled"];
export function isBookingStatus(value) {
    return BOOKING_STATUSES.some((status) => status === value);
}
